import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GA_ID = 'G-FNRFNSEJ4L';
const CONSENT_KEY = 'lazuli_cookie_consent';

function loadGA() {
  if (document.querySelector(`script[src*="${GA_ID}"]`)) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') { loadGA(); return; }
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    loadGA();
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(CONSENT_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Consentement aux cookies" className="fixed bottom-0 left-0 right-0 z-[60] bg-[#141C39] border-t border-white/10 shadow-[0_-4px_30px_rgba(0,0,0,0.2)]">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm text-white/70 font-dm leading-relaxed">
            Ce site utilise des cookies pour mesurer l'audience et améliorer votre expérience. En poursuivant, vous acceptez l'utilisation de cookies analytiques.
          </p>
          <Link to="/politique-de-confidentialite" className="text-sm text-[#FF8C4B] hover:underline font-dm mt-1 inline-block">En savoir plus</Link>
        </div>
        <div className="flex gap-3 shrink-0">
          <button data-testid="cookie-accept" onClick={accept}
            className="px-5 py-2 text-sm font-cabin font-semibold uppercase tracking-wide text-white bg-[#FF8C4B] hover:bg-[#e07a3e] rounded-[5px] transition-colors shadow-lg">
            Accepter
          </button>
          <button data-testid="cookie-refuse" onClick={refuse}
            className="px-5 py-2 text-sm font-cabin font-semibold uppercase tracking-wide text-white/50 hover:text-white border border-white/20 hover:border-white/40 rounded-[5px] transition-colors">
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
}
